import React from 'react';
import { StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import { getInitials } from './utils';
export const AvatarText = ({ name, primary, lastName, fontColor, xxSmall, xSmall, small, medium, large, }) => {
    const initials = getInitials(name, lastName);
    if (fontColor === undefined) {
        if (lastName) {
            return (<Text {...(primary ? {} : { White: true })} Text-14 style={styles.initials}>
          {initials}
        </Text>);
        }
        return (<Text White Text-20 style={styles.initials}>
        {initials}
      </Text>);
    }
    if (xxSmall) {
        if (lastName) {
            return (<Text Text-8 style={styles.initials} color={fontColor}>
          {initials}
        </Text>);
        }
        return (<Text Text-10 style={styles.initials} color={fontColor}>
        {initials}
      </Text>);
    }
    if (xSmall) {
        if (lastName) {
            return (<Text Text-10 style={styles.initials} color={fontColor}>
          {initials}
        </Text>);
        }
        return (<Text Text-12 style={styles.initials} color={fontColor}>
        {initials}
      </Text>);
    }
    if (small) {
        if (lastName) {
            return (<Text Text-14 style={styles.initials} color={fontColor}>
          {initials}
        </Text>);
        }
        return (<Text Text-16 style={styles.initials} color={fontColor}>
        {initials}
      </Text>);
    }
    if (medium) {
        if (lastName) {
            return (<Text Text-16 style={styles.initials} color={fontColor}>
          {initials}
        </Text>);
        }
        return (<Text Text-20 style={styles.initials} color={fontColor}>
        {initials}
      </Text>);
    }
    if (large) {
        if (lastName) {
            return (<Text Text-20 style={styles.initials} color={fontColor}>
          {initials}
        </Text>);
        }
        return (<Text Text-24 style={styles.initials} color={fontColor}>
        {initials}
      </Text>);
    }
    return (<Text Text-20 style={styles.initials} color={fontColor}>
      {initials}
    </Text>);
};
const styles = StyleSheet.create({
    initials: {
        textTransform: 'uppercase',
    },
});
